import { CountryItem } from 'src/components/country-bar/types';

/** Pourcentage de couverture (0-100) d'un pays, ou null si absent.
 *  `share_of_brand_searches` arrive DÉJÀ en pourcentage (main_overview.sql :
 *  safe_divide(...) * 100) — on arrondit sans re-multiplier. */
export const countryCoveragePct = (c: CountryItem): number | null =>
  typeof c.share_of_brand_searches === 'number'
    ? Math.round(c.share_of_brand_searches)
    : null;

/** Libellé texte d'un onglet pays : "FR (89%)" si coverage dispo, sinon "FR". */
export const formatCountryLabel = (c: CountryItem): string => {
  const code = (c.country_code ?? '').toUpperCase();
  const pct = countryCoveragePct(c);
  return pct != null ? `${code} (${pct}%)` : code;
};

/**
 * Liste de pays à envoyer au backend selon l'onglet sélectionné.
 * "ALL" (ou aucune sélection) => liste complète : le SQL filtre via
 * `region_name IN UNNEST(@countries)`, donc un tableau vide renverrait 0 ligne.
 * Le backend agrège alors correctement les métriques (les ratios ne se somment pas).
 */
export const countryFilterFor = (
  selected: string | null,
  allCountryNames: string[]
): string[] => (selected && selected !== 'ALL' ? [selected] : allCountryNames);
